var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/account.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import * as React from 'react';
import { Link, useHistory } from 'react-router-dom';
import HoverRefWrapper from 'soapbox/components/hover-ref-wrapper';
import VerificationBadge from 'soapbox/components/verification-badge';
import ExpertBadge from 'soapbox/components/expert-badge';
import ActionButton from 'soapbox/features/ui/components/action-button';
import { useAppSelector, useOnScreen } from 'soapbox/hooks';
import { getAcct } from 'soapbox/utils/accounts';
import { displayFqn } from 'soapbox/utils/state';
import RelativeTimestamp from './relative-timestamp';
import { Avatar, Emoji, HStack, Icon, IconButton, Stack, Text } from './ui';
import { getBadges } from 'soapbox/utils/badges';

const InstanceFavicon = _ref => {
  let {
    account
  } = _ref;
  const history = useHistory();

  const handleClick = e => {
    e.stopPropagation();
    const timelineUrl = "/timeline/".concat(account.domain);

    if (!(e.ctrlKey || e.metaKey)) {
      history.push(timelineUrl);
    } else {
      window.open(timelineUrl, '_blank');
    }
  };

  return /*#__PURE__*/React.createElement("button", {
    className: "w-4 h-4 flex-none focus:ring-primary-500 focus:ring-2 focus:ring-offset-2",
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: account.favicon,
    alt: "",
    title: account.domain,
    className: "w-full max-h-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 7
    }
  }));
};

const ProfilePopper = _ref2 => {
  let {
    condition,
    wrapper,
    children
  } = _ref2;
  return condition ? wrapper(children) : children;
};

const Account = _ref3 => {
  let {
    account,
    actionType,
    action,
    actionIcon,
    actionTitle,
    actionAlignment = 'center',
    avatarSize = 42,
    hidden = false,
    hideActions = false,
    onActionClick,
    showProfileHoverCard = true,
    timestamp,
    timestampUrl,
    futureTimestamp = false,
    withAccountNote = false,
    withDate = false,
    withLinkToProfile = true,
    withRelationship = true,
    showEdit = false,
    emoji
  } = _ref3;
  const overflowRef = React.useRef(null);
  const actionRef = React.useRef(null); // @ts-ignore

  const isOnScreen = useOnScreen(overflowRef);
  const [style, setStyle] = React.useState({
    visibility: 'hidden'
  });
  const me = useAppSelector(state => state.me);
  const username = useAppSelector(state => account ? getAcct(account, displayFqn(state)) : null);

  const handleAction = () => {
    // @ts-ignore
    onActionClick(account);
  };

  const renderAction = () => {
    if (action) {
      return action;
    }

    if (hideActions) {
      return null;
    }

    if (onActionClick && actionIcon) {
      return /*#__PURE__*/React.createElement(IconButton, {
        src: actionIcon,
        title: actionTitle,
        onClick: handleAction,
        className: "bg-transparent text-gray-600 dark:text-gray-600 hover:text-gray-700 dark:hover:text-gray-500",
        iconClassName: "w-4 h-4",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124,
          columnNumber: 9
        }
      });
    }

    if (account.id !== me) {
      return /*#__PURE__*/React.createElement(ActionButton, {
        account: account,
        actionType: actionType,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 135,
          columnNumber: 14
        }
      });
    }

    return null;
  };

  React.useEffect(() => {
    var _actionRef$current;

    const style = {};
    const actionWidth = ((_actionRef$current = actionRef.current) === null || _actionRef$current === void 0 ? void 0 : _actionRef$current.clientWidth) || 0;

    if (overflowRef.current) {
      style.maxWidth = overflowRef.current.clientWidth - 30 - avatarSize - actionWidth;
    } else {
      style.visibility = 'hidden';
    }

    setStyle(style);
  }, [isOnScreen, overflowRef, actionRef]);

  if (!account) {
    return null;
  }

  if (hidden) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, account.display_name, account.username);
  }

  if (withDate) timestamp = account.created_at;
  const LinkEl = withLinkToProfile ? Link : 'div';
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "account",
    className: "flex-shrink-0 group block w-full",
    ref: overflowRef,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 172,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: actionAlignment,
    justifyContent: "between",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: withAccountNote ? 'top' : 'center',
    space: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 174,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ProfilePopper, {
    condition: showProfileHoverCard,
    wrapper: children => /*#__PURE__*/React.createElement(HoverRefWrapper, {
      className: "relative",
      accountId: account.id,
      inline: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 177,
        columnNumber: 36
      }
    }, children),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 175,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(LinkEl, {
    to: "/@".concat(account.acct),
    title: account.acct,
    onClick: event => event.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: account.avatar,
    size: avatarSize,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 184,
      columnNumber: 15
    }
  }), emoji && /*#__PURE__*/React.createElement(Emoji, {
    className: "w-5 h-5 absolute -bottom-1.5 -right-1.5",
    emoji: emoji,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 186,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 194,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(ProfilePopper, {
    condition: showProfileHoverCard,
    wrapper: children => /*#__PURE__*/React.createElement(HoverRefWrapper, {
      accountId: account.id,
      inline: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 197,
        columnNumber: 38
      }
    }, children),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 195,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(LinkEl, {
    to: "/@".concat(account.acct),
    title: account.acct,
    onClick: event => event.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 199,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center space-x-1 flex-grow",
    style: style,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 204,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    weight: "semibold",
    truncate: true,
    dangerouslySetInnerHTML: {
      __html: account.display_name_html
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 205,
      columnNumber: 19
    }
  }), account.verified && /*#__PURE__*/React.createElement(VerificationBadge, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 212,
      columnNumber: 40
    }
  }), /*#__PURE__*/React.createElement(ExpertBadge, {
    badges: getBadges(account),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 213,
      columnNumber: 19
    }
  })))), /*#__PURE__*/React.createElement(Stack, {
    space: withAccountNote ? 1 : 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 218,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 1,
    style: style,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 219,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    truncate: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 220,
      columnNumber: 17
    }
  }, "@", username), account.favicon && /*#__PURE__*/React.createElement(InstanceFavicon, {
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 19
    }
  }), timestamp ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 228,
      columnNumber: 21
    }
  }, "\xB7"), timestampUrl ? /*#__PURE__*/React.createElement(Link, {
    to: timestampUrl,
    className: "hover:underline",
    onClick: event => event.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231,
      columnNumber: 23
    }
  }, /*#__PURE__*/React.createElement(RelativeTimestamp, {
    timestamp: timestamp,
    theme: "muted",
    size: "sm",
    className: "whitespace-nowrap",
    futureDate: futureTimestamp,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 232,
      columnNumber: 25
    }
  })) : /*#__PURE__*/React.createElement(RelativeTimestamp, {
    timestamp: timestamp,
    theme: "muted",
    size: "sm",
    className: "whitespace-nowrap",
    futureDate: futureTimestamp,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 235,
      columnNumber: 23
    }
  })) : null, showEdit ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 242,
      columnNumber: 21
    }
  }, "\xB7"), /*#__PURE__*/React.createElement(Icon, {
    className: "h-5 w-5 text-gray-700 dark:text-gray-600",
    src: require('@tabler/icons/pencil.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 244,
      columnNumber: 21
    }
  })) : null, actionType === 'muting' && account.mute_expires_at ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 250,
      columnNumber: 21
    }
  }, "\xB7"), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 252,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(RelativeTimestamp, {
    timestamp: account.mute_expires_at,
    futureDate: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 252,
      columnNumber: 51
    }
  }))) : null), withAccountNote && /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    dangerouslySetInnerHTML: {
      __html: account.note_emojified
    },
    className: "mr-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 258,
      columnNumber: 17
    }
  })))), /*#__PURE__*/React.createElement("div", {
    ref: actionRef,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 268,
      columnNumber: 9
    }
  }, withRelationship ? renderAction() : null)));
};

export default Account;